import React, { useContext, useState, useEffect } from "react";
import {
  AppBar,
  Box,
  Toolbar,
  Badge,
  useMediaQuery,
  IconButton,
  Button,
} from "@material-ui/core";
import { ShoppingCart } from "@material-ui/icons";
import BrandIcon from "../BrandIcon/BrandIcon";
import "./NavBar.css";
import { Link } from "react-router-dom";
import { CartContext } from "../CartContext/CartContext";
import TemporaryDrawer from "./TemporaryDrawer";
import Busqueda from "../Busqueda/Busqueda";
import Account from "../Account/Account";
import Cookies from "universal-cookie";
import axios from "axios";
import { config } from "../../config/config";
// import ApiQuery from "../utils/apiQuery/apiQuery"
// let apiQuery = new ApiQuery();

const cookies = new Cookies();
const usuarioCookie = cookies.get("user");

export default function NavBar() {
  const cartContext = useContext(CartContext);
  const { cart, user } = cartContext;
  const [quantity, setQuantity] = useState(0);
  const isMobile = useMediaQuery("(max-width:900px)");
  const [usuario, setUsuario] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let total = 0;
    for (const prod of cart) {
      total += prod.qty;
    }
    setQuantity(total);
  }, [cart]);

  useEffect(() => {
    setUsuario(usuarioCookie);
  }, [user, cart]);

  useEffect(() => {
    const token = cookies.get("token");
    if (!token) {
      setIsAdmin(false);
      return undefined;
    }

    let cancelled = false;
    axios.get(`${config.SERVER}/api/auth/session`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(({ data }) => {
        if (cancelled) return;
        const role = data?.user?.isAdmin;
        setIsAdmin(role === true || role === "true" || role === "on");
      })
      .catch(() => {
        if (!cancelled) setIsAdmin(false);
      });

    return () => {
      cancelled = true;
    };
  }, [user]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        color="primary"
        enableColorOnDark
        sx={{ backgroundColor: "#082b66", color: "#ffffff" }}
      >
        <Toolbar className="toolBar">
          <div className="logo">
            <Link
              aria-label="Ir al inicio del catálogo"
              style={{
                textDecoration: "none",
                color: "inherit",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
              to={`/home`}
            >
              <BrandIcon />
              {/* <Typography variant="h6" component="div" sx={{ flexGrow: 1, marginRight: "2rem" }}>
                Tecnalink
              </Typography> */}
            </Link>

            {isMobile ? (
              <></>
            ) : (
              <>
                {usuario ? (
                  <>
                    {/* <Category2 lista="bremen"/> <CategoryTekbond/>  */}
                    {/* {navList.map((item) => (
                <Category2 key={item} lista={item}/>
                        ))}             */}
                  </>
                ) : (
                  <></>
                )}
                {/* <Category2/> */}
                {/* <Busqueda/> */}
                {/* <ModeTheme/>
            <Logout /> */}
              </>
            )}
          </div>
            {isMobile ? (
              <Box
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                {usuario ? (
                  <IconButton
                    component={Link}
                    to="/cart"
                    color="inherit"
                    aria-label={`Ver pedido (${quantity} ${quantity === 1 ? "unidad" : "unidades"})`}
                  >
                    <Badge badgeContent={quantity} color="error">
                      <ShoppingCart />
                    </Badge>
                  </IconButton>
                ) : (
                  <Link
                    to="/login"
                    style={{ textDecoration: "none", color: "inherit", marginRight: "8px" }}
                  >
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        backgroundColor: "#ffffff",
                        color: "#082b66",
                        fontWeight: "bold",
                        borderRadius: "20px",
                        fontSize: "11px",
                        px: 1.5,
                        py: 0.5,
                        "&:hover": {
                          backgroundColor: "#edf1f6",
                        },
                      }}
                    >
                      Iniciar Sesión
                    </Button>
                  </Link>
                )}
                {usuario && isAdmin && (
                  <Button
                    component="a"
                    href={config.ADMINISTRADOR}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="outlined"
                    size="small"
                    aria-label="Abrir panel administrador"
                    style={{ color: "inherit", borderColor: "rgba(255,255,255,0.7)", marginRight: "8px", fontSize: "11px" }}
                  >
                    Admin
                  </Button>
                )}
                <TemporaryDrawer />
              </Box>
            ) : (
              <>
                {usuario ? (
                  <>
                    <Box
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Busqueda />
                      {/* <OrderButton/> */}
                      <IconButton
                        component={Link}
                        to="/cart"
                        color="inherit"
                        aria-label={`Ver pedido (${quantity} ${quantity === 1 ? "unidad" : "unidades"})`}
                      >
                        <Badge badgeContent={quantity} color="error">
                          <ShoppingCart />
                        </Badge>
                      </IconButton>
                      {isAdmin && (
                        <Button
                          component="a"
                          href={config.ADMINISTRADOR}
                          target="_blank"
                          rel="noopener noreferrer"
                          variant="outlined"
                          size="small"
                          aria-label="Abrir panel administrador"
                          style={{ color: "inherit", borderColor: "rgba(255,255,255,0.7)", margin: "0 8px", fontWeight: "bold" }}
                        >
                          Administrador
                        </Button>
                      )}
                      <Account />
                      {/* <PermanentDrawer/> */}
                    </Box>
                  </>
                ) : (
                  <Box
                    style={{
                      textDecoration: "none",
                      color: "inherit",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Busqueda />
                    <Link
                      to="/login"
                      style={{ textDecoration: "none", color: "inherit", marginLeft: "15px" }}
                    >
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          backgroundColor: "#ffffff",
                          color: "#082b66",
                          fontWeight: "bold",
                          borderRadius: "20px",
                          px: 2,
                          "&:hover": {
                            backgroundColor: "#edf1f6",
                          },
                        }}
                      >
                        Iniciar Sesión
                      </Button>
                    </Link>
                  </Box>
                )}
                {/* <Box style={{textDecoration: "none", color: "inherit", display: "flex", flexDirection: "row", alignItems: "center",}}>
                      <Link to={`/cart`} style={{ textDecoration: "none", color: "inherit" }}>
                        <Badge badgeContent={quantity} color="error">
                          <ShoppingCart />
                        </Badge>
                      </Link>
                      <Account/>
                    </Box> */}
              </>
            )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
